import type { ComponentProps } from 'react'
import { cn } from '../lib/cn'
export function Navigation({
  className,
  appearance = 'sidebar',
  ...props
}: ComponentProps<'nav'> & { appearance?: 'sidebar' | 'pill' }) {
  return (
    <nav
      {...props}
      data-slot="navigation"
      className={cn(appearance === 'sidebar' ? 'space-y-5' : 'flex flex-wrap gap-2', className)}
    />
  )
}
export function NavigationSection({ className, ...props }: ComponentProps<'div'>) {
  return <div {...props} className={cn('space-y-1', className)} />
}
export function NavigationSectionHeading({ className, ...props }: ComponentProps<'h2'>) {
  return (
    <h2
      {...props}
      className={cn(
        'px-3 pb-2 text-[9px] font-bold uppercase tracking-[0.2em] text-action',
        className,
      )}
    />
  )
}
export function navigationItemStyles({
  active = false,
  appearance = 'sidebar',
  activeAppearance = 'subtle',
  className,
  size = 'md',
}: {
  active?: boolean
  appearance?: 'sidebar' | 'pill'
  activeAppearance?: 'subtle' | 'solid'
  className?: string
  size?: 'sm' | 'md'
} = {}) {
  return cn(
    'flex items-center gap-3 font-medium transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring aria-disabled:pointer-events-none aria-disabled:opacity-60',
    appearance === 'pill' ? 'rounded-full' : 'rounded-control',
    size === 'sm' ? 'min-h-8 px-3 py-1 text-[13px]' : 'min-h-11 px-3.5 py-2 text-sm',
    active
      ? activeAppearance === 'solid'
        ? 'bg-action text-action-foreground shadow-button hover:bg-action-hover'
        : 'bg-accent text-accent-foreground'
      : 'text-muted-foreground hover:bg-muted hover:text-foreground',
    className,
  )
}
